
document.addEventListener('DOMContentLoaded', () => {
  function customParallax(){
    const parallaxText = document.querySelector('.about-mission-section .image-with-text-content-block .image-with-text-content');
    if (window.innerWidth<750) return
    if (!parallaxText) return;

    window.addEventListener('scroll', () => {
      const rect = parallaxText.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // Check if section is in view
      if (rect.top < windowHeight && rect.bottom > 0) {
        // Adjust speed (lower value = slower movement)
        const speed = 0.1;
        const offset = (windowHeight - rect.top) * speed;
        parallaxText.style.transform = `translateY(${offset * -3.2}px)`;
      }
    });
  }
  customParallax();

  if(document.querySelector(".about-local-importance .rich-text-text>p")){
    const text = document.querySelector(".about-local-importance .rich-text-text>p").innerText;
    const textContainer = document.querySelector(".about-local-importance .rich-text-text>p");
    textContainer.innerHTML = '';

    text.split("").forEach(char => {
      const span = document.createElement("span");
      span.textContent = char;
      textContainer.appendChild(span);
    });

    const letters = textContainer.querySelectorAll("span");
    let index = 0;

    function animate() {
      //letters.forEach((letter, i) => letter.style.opacity = 0.2);
      letters[index].style.opacity = 1;

      index = (index + 1) % letters.length;
      if(index == 0 ){
        letters.forEach((letter, i) => letter.style.opacity = 0.2);
      }
    }

    setInterval(animate, 150);
  
  }
  
});
